import { Injectable } from '@angular/core';
import { HttpGeneralService, EmrParms } from '../../shared/shared';
import { CONFIG } from '../../shared/config';
const medicalSheetsUrl = CONFIG.baseUrls.medicalSheets;

let emrHtmlTemplatesUrl = CONFIG.baseUrls.emrHtmlTemplates;
export interface EmrHtmlTemplates {
    serial?: number;
    nameAr?: string;
    nameEn?: string;
    htmlContent?: string;
    priServiceStpCode?: number;
    type?: number;
    valid?: number;
    headerBodyFlag?: number;
    serviceCodeLevelTwo?: number
    gender?: number
    docId?: number
    langId?: number
    mainHeader ?: number
    staticHeader?:number
}

@Injectable()
export class EmrHtmlTemplatesService {
    constructor(private httpGeneralService: HttpGeneralService) { }

    getEmrHtmlTemplates(id: number) {
        return this.httpGeneralService.get(id, emrHtmlTemplatesUrl);
    }
    getRadRepMainHeader(maiHeader: any) {
        return this.httpGeneralService.post(maiHeader, `${medicalSheetsUrl}/reports/GetRadRepMainHeader`);
      }
    searchRepContents(repContent: EmrParms) {
        return this.httpGeneralService.add<EmrParms>(repContent, `${emrHtmlTemplatesUrl}/Search`);
    }

    addEmrHtmlTemplates(emrHtmlTemplates: EmrHtmlTemplates) {
        return this.httpGeneralService.add<EmrHtmlTemplates>(emrHtmlTemplates, emrHtmlTemplatesUrl);
    }

    updateEmrHtmlTemplates(emrHtmlTemplates: EmrHtmlTemplates) {
        return this.httpGeneralService.update<EmrHtmlTemplates>(emrHtmlTemplates.serial, emrHtmlTemplates, emrHtmlTemplatesUrl);
    }

    deleteEmrHtmlTemplates(emrHtmlTemplates: EmrHtmlTemplates) {
        return this.httpGeneralService.delete<number>(emrHtmlTemplates.serial, emrHtmlTemplatesUrl);
    }
    ///////////////////////////////////////////////hr contract templates//////////////////////////////
    getHrContractHtmlTemplates(id: number) {
        return this.httpGeneralService.get(id, `${emrHtmlTemplatesUrl}/getHrContractHtmlTemplates`);
    }
    searchHrContractTemplates(repContent: EmrParms) {
        return this.httpGeneralService.add<EmrParms>(repContent, `${emrHtmlTemplatesUrl}/searchHrContractTemplates`);
    }
    addHrContractTemplates(emrHtmlTemplates: EmrHtmlTemplates) {
        return this.httpGeneralService.add<EmrHtmlTemplates>(emrHtmlTemplates, `${emrHtmlTemplatesUrl}/addHrContractTemplates`);
    }

    updateHrContractTemplates(emrHtmlTemplates: EmrHtmlTemplates) {
        return this.httpGeneralService.update<EmrHtmlTemplates>(emrHtmlTemplates.serial, emrHtmlTemplates, `${emrHtmlTemplatesUrl}/updateHrContractTemplates`);
    }

    deleteHrContractTemplates(emrHtmlTemplates: EmrHtmlTemplates) {
        return this.httpGeneralService.delete<number>(emrHtmlTemplates.serial, `${emrHtmlTemplatesUrl}/deleteHrContractTemplates`);
    }



}
